module.exports = __webpack_public_path__ + "img/message-alert-circle.c99f9cfb.svg";